import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock } from "react-icons/fa";
import COLORS from "../../constants/colors";
import Loginleftimg from "../../assets/images/login_left_img.png";
import { useLoginMutation } from "../../api/auth";
import { notifySuccess, notifyError } from "../../utils/ToastifyProvider";
import { useLoader } from "../../utils/LoaderContext";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [focusedInput, setFocusedInput] = useState("");
  const { setLoading } = useLoader();

  const { mutate, isLoading } = useLoginMutation();

  const handleFormSubmit = (e) => {
    e.preventDefault();

    setLoading(true); // ✅ Start global loader

    mutate(
      { email, password },
      {
        onSuccess: (data) => {
          notifySuccess("Login successful!");
          navigate("/dashboard");
          setLoading(false); // ✅ Stop loader
        },
        onError: (err) => {
          notifyError(
            err.response?.data?.message || "Login failed. Please try again."
          );
          setLoading(false); // ✅ Stop loader
        },
      }
    );
  };

  return (
    <>
      <div className="flex flex-col md:flex-row w-full h-screen bg-white">
        {/* Logo */}
        <div className="absolute top-4 left-6 flex items-center gap-3">
          {/* <img src={Image} alt="Logo" className="w-[170px] md:w-[200px]" /> */}
        </div>

        {/* Left Image */}
        <div className="hidden md:flex flex-1 items-center justify-end pr-8">
          <img
            src={Loginleftimg}
            alt="Illustration"
            className="w-[90%] h-1/2 object-contain"
          />
        </div>

        {/* Right Form */}
        <div className="flex flex-1 items-center px-6">
          <form
            onSubmit={handleFormSubmit}
            className="w-full max-w-md flex flex-col gap-6"
          >
            <div>
              <h1 className="text-5xl font-bold">Welcome Back!</h1>
              <p className="text-gray-500 mt-1 text-xl">Login to continue</p>
            </div>

            {/* Email Input */}
            <div className="relative">
              <FaUser
                className={`absolute top-3.5 left-4 text-2xl transition ${
                  focusedInput === "email"
                    ? COLORS.iconFocus
                    : COLORS.iconDefault
                }`}
              />
              <input
                type="email"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onFocus={() => setFocusedInput("email")}
                onBlur={() => setFocusedInput("")}
                className={`w-full border border-solid rounded-md py-3 px-14 focus:outline-none transition text-lg ${
                  focusedInput === "email"
                    ? COLORS.borderFocus
                    : COLORS.borderDefault
                }`}
                required
              />
            </div>

            {/* Password Input */}
            <div className="relative">
              <FaLock
                className={`absolute top-3.5 left-4 text-2xl transition ${
                  focusedInput === "password"
                    ? COLORS.iconFocus
                    : COLORS.iconDefault
                }`}
              />
              <input
                type="password"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={() => setFocusedInput("password")}
                onBlur={() => setFocusedInput("")}
                className={`w-full border rounded-md py-3 px-14 focus:outline-none text-lg transition ${
                  focusedInput === "password"
                    ? COLORS.borderFocus
                    : COLORS.borderDefault
                }`}
                required
              />
            </div>

            {/* Buttons */}
            <div className="flex flex-wrap items-center gap-4 mt-2">
              <button
                type="submit"
                className={`bg-primary ${COLORS.textWhite} rounded-full px-6 py-2 font-medium hover:opacity-90`}
                disabled={isLoading}
              >
                {isLoading ? "Logging in..." : "Login"}
              </button>
              {/* <button
                type="button"
                className={`border border-[${COLORS.primary}] text-[${COLORS.primary}] rounded-full px-6 py-2 font-medium hover:bg-[${COLORS.primaryLight}]`}
                onClick={() => navigate("/registration")}
              >
                Registration
              </button>
              <button
                type="button"
                onClick={() => navigate("/forgotpass")}
                className={`text-sm ${COLORS.textBlack} hover:underline ml-auto`}
              >
                FORGET PASSWORD?
              </button> */}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
